import React, { useState } from "react";
import { Button, Card, Form, Input, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
//import { Link } from "react-router-dom";
import _v from "validator";
import i18n from "../../utils/i18n/pt-BR";

//Redux
import { useDispatch } from "react-redux";
import { handleLoginLight } from "../../store/auth/auth.actions";

//styles
import "../../assets/css/auth/login.css";

const LoginPage = () => {
  const dispatch = useDispatch();

  //local varibales
  const [inputValues, setInputValues] = useState({
    email: "",
    password: "",
  });

  //set input values
  const handleChange = (e) => {
    const { value, id } = e.target;
    setInputValues({ ...inputValues, [id]: value });
  };

  //validate inputs
  const validateInputs = () => {
    let error = "";

    if (_v.isEmpty(inputValues.email)) {
      error = i18n.INPUT_EMAIL_EMPTY;
    } else if (!_v.isEmail(inputValues.email)) {
      error = i18n.INPUT_EMAIL_INVALID;
    } else if (!_v.isLength(inputValues.email, { min: 6, max: 150 })) {
      error = i18n.INPUT_EMAIL_MINMAX_SIZE;
    } else if (_v.isEmpty(inputValues.password)) {
      error = i18n.INPUT_PASSWORD_EMPTY;
    } else if (!_v.isLength(inputValues.password, { min: 6, max: 64 })) {
      error = i18n.INPUT_PASSWORD_MINMAX_SIZE;
    }

    if (error !== "") {
      message.warning({
        content: error,
        key: "login",
        duration: 2,
      });
      return false;
    }

    return true;
  };

  //fazendo o login
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateInputs()) {
      message.loading({
        content: i18n.VALIDATING_ACCESS,
        key: "login",
        duration: 10,
      });

      const { email, password } = inputValues;
      dispatch(handleLoginLight({ email, password }));
    }
  };

  return (
    <div id="login-page" className="space-align-container">
      <Card
        className="space-align-block"
        style={{ width: 300, margin: "auto" }}
      >
        <Form
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="login"
          initialValues={{ remember: true }}
        >
          <Form.Item>
            <div className="logo-login" />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              { required: true, message: "Por favor, insira seu e-mail!" },
            ]}
          >
            <Input
              id="email"
              name="email"
              prefix={<UserOutlined />}
              placeholder="E-mail"
              value={inputValues.email}
              onChange={(e) => handleChange(e)}
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Por favor, insira sua senha!" },
            ]}
          >
            <Input.Password
              id="password"
              name="password"
              prefix={<LockOutlined />}
              placeholder="Senha"
              value={inputValues.password}
              onChange={(e) => handleChange(e)}
            />
          </Form.Item>
          <Form.Item>
            <Button
              block
              type="primary"
              htmlType="submit"
              onClick={(e) => handleSubmit(e)}
            >
              ENTRAR
            </Button>
          </Form.Item>
          {/* <Form.Item>
            <Link to="/redefinir-senha">Esqueceu a senha?</Link>
          </Form.Item> */}
        </Form>
      </Card>
    </div>
  );
};

export default LoginPage;
